import React, { useState, useRef, useEffect } from "react";
import { useSelector } from "react-redux";
import ReactPlayer from "react-player";
import { CircularProgress, Typography } from "@material-ui/core";
import { getAppColor } from "@icarius-app/selectors";
import { getAuthInfo } from "@icarius-pages/login/sessionStorage";

const MediaPlayer = (props) => {
    const { url, isURLToFetchBlob, timestamp } = props;

    const [videoUrl, setVideoUrl] = useState(() => (!isURLToFetchBlob ? url : null));
    const [hasError, setHasError] = useState(false);
    const [isPlayerReady, setIsPlayerReady] = useState(false);

    const playerRef = useRef();
    const color = useSelector(getAppColor);

    useEffect(() => {
        if (!isURLToFetchBlob) return;

        const controller = new AbortController();
        let objectURL = null;
        let isMounted = true;

        const loadVideo = async () => {
            try {
                const response = await fetch(url, {
                    headers: {
                        Authorization: `Bearer ${getAuthInfo().token}`,
                    },
                    signal: controller.signal,
                });

                if (response.status !== 200) throw new Error(response.statusText);

                const blob = await response.blob();
                objectURL = URL.createObjectURL(blob);

                if (!isMounted) return;

                setVideoUrl(objectURL);
                setHasError(false);
            } catch (e) {
                if (e.name === "AbortError") return;

                if (!isMounted) return;

                console.log(e);
                setHasError(true);
            }
        };

        loadVideo();

        return () => {
            isMounted = false;
            controller.abort();
            if (objectURL) URL.revokeObjectURL(objectURL);
        };
    }, [isURLToFetchBlob, url]);

    const onReady = () => {
        if (isPlayerReady) return;
        if (timestamp) playerRef.current.seekTo(timestamp, "seconds");
        setIsPlayerReady(true);
    };

    if (!url) return null;

    return (
        <div
            style={{
                width: "100%",
                height: "100%",
                background: "black",
                position: "relative",
            }}
        >
            {url && (
                <ReactPlayer
                    ref={playerRef}
                    url={videoUrl}
                    width={"100%"}
                    height={"100%"}
                    controls={true}
                    onReady={onReady}
                    // onProgress={(e) => console.log(e.playedSeconds)}
                />
            )}
            {!isPlayerReady && (
                <div
                    style={{
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        top: 0,
                        left: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    {hasError && <Typography className="whiteText">{"Error"}</Typography>}
                    {url && isURLToFetchBlob && !hasError && <CircularProgress style={{ color }} />}
                </div>
            )}
        </div>
    );
};

export default MediaPlayer;
